import PropTypes from "prop-types";

export default function CustomizeSection({ children, title, className }) {
  return (
    <fieldset
      className={`fieldset bg-base-200 border border-base-300 px-4 pt-1 pb-3 rounded-box mt-1 ${className}`}
    >
      <legend className="fieldset-legend font-extrabold text-base select-none">{title}</legend>
      {children}
    </fieldset>
  );
}

CustomizeSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};
